// Angular 2
import {Component, ViewChild, provide} from '@angular/core';
import {Http, HTTP_PROVIDERS} from '@angular/http';

// Ionic 2
import {Platform, Nav, ionicBootstrap, MenuController} from 'ionic-angular';
import {StatusBar} from 'ionic-native';

// App pages
import {SearchPage} from './pages/search/search';
import {EtaPage} from './pages/eta/eta'
import {MapPage} from './pages/map/map';
import {RoutePage} from './pages/route/route';
import {ContactPage} from './pages/contact/contact';
import {SettingsPage} from './pages/settings/settings';

// Firebase
import {FIREBASE_PROVIDERS, defaultFirebase, AngularFire} from 'angularfire2';

// ng2-translate
import {TranslateService, TranslatePipe, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';


@Component({
  templateUrl: 'build/app.html',
  pipes: [TranslatePipe]
})
class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = SearchPage;
  pages: Array<{title: string, icon: string, component: any}>

  constructor(public platform: Platform, public translate: TranslateService) {
    this.initializeApp();
    
    this.pages = [
      { title: 'search', icon: 'search', component: SearchPage},
      { title: 'eta', icon: 'time', component: EtaPage},
      { title: 'map', icon: 'map', component: MapPage},
      { title: 'route', icon: 'navigate', component: RoutePage},
      { title: 'contact', icon: 'call', component: ContactPage},
      { title: 'settings', icon: 'settings', component: SettingsPage}
    ];

    this.translateConfig();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      StatusBar.styleDefault();
    });
  }
  
  openPage(page) {
    this.nav.setRoot(page.component);
  }

  translateConfig() {
    let userLang = navigator.language.split('-')[0];
    userLang = /(de|en|es|fr)/gi.test(userLang) ? userLang : 'es';
    this.translate.setDefaultLang('en');
    this.translate.use(userLang);
  }
}

ionicBootstrap(
    MyApp, 
    [
      FIREBASE_PROVIDERS,
      defaultFirebase('https://loymerbus.firebaseio.com'),
      {
        provide: TranslateLoader,
        useFactory: (http: Http) => new TranslateStaticLoader(http, 'assets/i18n', '.json'),
        deps: [Http]
      },
      TranslateService
    ],
    {}
);
